<template>
    <div :class="{'is-nv-lead': isNvLead}">
        <router-link :to="detailRoute" :key="'form-details-link-' + lead.id"
                     class="list-group-item list-group-item-action details-bar d-flex justify-content-between align-items-center lead-row align-items-stretch"
                     :class="{'list-group-item-read': lead.read, 'list-group-item-unread': !lead.read, 'list-group-item-finished': lead.finished_at !== null}">

            <div class="t t-tool prevented" @click.prevent="select">
                <b-form-checkbox data-hj-whitelist
                    v-if="lead.finished_at === null"
                    v-model="localValue"
                    :value="lead.id"
                    :unchecked-value="lead.id">
                </b-form-checkbox>
            </div>

            <div class="t t-id">
                <div class="data">
                    {{lead.id}}
                </div>
            </div>

            <div class="t t-status">
                <div class="data">
                    <div class="badge mr-2 badge-info" v-bind:style="{backgroundColor: lead.status.color}"><i v-if="lead.finished_at !== null" class="fas fa-check mr-2"></i>{{lead.status.title}}</div>
                    <small v-if="lead.ep_nr !== null"><br />Reserveringsnummer: {{lead.ep_nr}}</small>
                </div>
            </div>

            <div class="t t-source">
                <div class="data">
                    <div class="badge badge-white source">
                        <div class="dot" :style="{'background': lead.source.color}"></div>
                        {{lead.source.name}}
                    </div>
                </div>
            </div>

            <div class="t t-form">
                <div class="data">
                    {{lead.form}}
                </div>
            </div>

            <div class="t t-email" v-tooltip="lead.values.email">
                <div class="data">
                    {{lead.values.email}}
                </div>
            </div>

            <div class="t t-created" v-tooltip="moment(lead.created_at).format('LLLL')">
                <div class="data">
                    {{ date(lead.created_at) }}<br />
                    {{moment(lead.created_at).format('LT')}}
                </div>
            </div>

            <div class="t t-timer">
                <div class="data">
                    <timer
						:due="lead.response_due.dueDate"
						:elapsed="lead.response_due.elapsed"
						:remaining="lead.response_due.remaining"
						:is-open="lead.response_due.isOpen"
						:switch-on="lead.response_due.until"
						:completed="lead.response_due.respondedAt"
					></timer>
                </div>
            </div>

            <div class="t t-assignee prevented" @click.prevent="preventer">
                <div class="data" v-if="lead.assignee" v-tooltip="lead.assignee.name">
                    {{lead.assignee.name}}
                </div>
                <div class="data" v-else>
                    <a @click="selectAssignee('assigneeInput-'+ lead.id)" class="text-primary force">Wijs toe aan</a>
                </div>
            </div>

            <div class="t t-extra text-right">
                <em class="toggle fa fa-chevron-right"></em>
            </div>
        </router-link>

        <assignee :ref="'assigneeInput-'+ lead.id" :tiny="true" :lead="lead" :updateable="!(lead.status && lead.status.finished)" @updated="updated"></assignee>
    </div>
</template>

<script>
    import Timer from "./timer";
    import Assignee from "./assignee";

    export default {
        components: {
            Assignee,
            Timer
        },
        props: {
            lead: {
                type: Object,
                required: false
            },
            value: {
                type: Array,
                required: false
            },
        },
        data() {
            return {
                localValue: [],
            }
        },
        computed: {
            isNvLead() {
              return this.lead.is_nv_lead;
            },
            detailRoute() {
                return {
                    name: this.isNvLead ? 'nv-lead.details' : 'lead.details',
                    params: {
                        leadId: this.lead.id
                    }
                }
            }
        },
        watch: {
            value() {
                this.localValue = this.value;
            },
            localValue() {
                this.$emit('input', this.localValue);
            }
        },
        mounted() {
            this.localValue = this.value;
        },
        methods: {
            preventer() {
            },
            select() {
                if (this.localValue.indexOf(this.lead.id) > -1) {
                    this.localValue.splice(this.localValue.indexOf(this.lead.id), 1)
                } else {
                    this.localValue.push(this.lead.id);
                }
            },
            date(date) {
                let now = this.moment();
                let nowCheck = this.moment().startOf("day");
                let yest = this.moment().subtract(1, "day").startOf("day");
                let mom = this.moment(date).startOf("day");
                if (mom.isSame(now, 'day')) {
                    return 'Vandaag';
                } else if (mom.isSame(yest, 'day')) {
                    return 'Gisteren';
                }
                return mom.format('L');
            },
            updated(data) {
                this.$emit('updated', data);
            },
            selectAssignee(ref) {
                this.$refs[ref].$refs[this.$refs[ref]._uid + '-form-view-employees' + this.lead.id].show();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .source {
        color: #212529;
        max-width: 360px;
        .card-body {
            padding: 0.8rem;
        }
        &:has([href]), &:has([tabindex]) {
            &:hover {
                text-decoration: none;
                box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.2);
            }
            &:active {
                text-decoration: none;
                box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.4);
            }
        }
    }
    .is-nv-lead {
        .t-form {
            &:before {
                content: '';
                display: block;
                width: 16px;
                height: 17px;
                margin: 0 2px 0 0;
                background-image: url("/img/x.svg");
                background-repeat: no-repeat;
            }
        }
    }

</style>